import React, {useState, useEffect} from 'react';
import {useContext, useContextSelector} from 'use-context-selector';
import {useHistory} from "react-router-dom";
import {ButtonToolbar, Button} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {useBreakpoint} from '../util/handleBreakpoints';

import createUUID from '../util/createUUID';

import initialLocalData from '../context/initialLocalData';
import initialSessionData from '../context/initialSessionData';

import {LocalContext} from '../context/LocalContext';
import {SessionContext} from '../context/SessionContext';

const AuthActions = () => {
    const {t} = useTranslation();
    const breakpoints = useBreakpoint();

    const setSessionData = useContext(SessionContext)[1];
    const setLocalData = useContext(LocalContext)[1];

    const clientOnline = useContextSelector(LocalContext, v => v[0].clientOnline);
    const userAuthenticated = useContextSelector(LocalContext, v => v[0].user.authenticated);

    const cookiesPolicy = useContextSelector(LocalContext, v => v[0].cookiesPolicy);
    const [logout, setLogout] = useState(false);

    let history = useHistory();

    useEffect(() => {
        if (logout) {
            setLogout(false);
            history.push("/");

            setLocalData({
                ...initialLocalData,
                clientOnline,
                cookiesPolicy: {
                    ...cookiesPolicy
                }
            });
            setSessionData({
                ...initialSessionData,
            });
        }
    }, [logout, setLogout, clientOnline, setSessionData, setLocalData, cookiesPolicy, history]);

    return <ButtonToolbar className="flex-grow-1 flex-lg-grow-0 my-lg-0"
        style={
            {
                ...(breakpoints.md ? {
                    borderTop: '1px solid rgba(255,255,255,0.15)',
                    padding: '0.5rem 1rem'
                } : {})
            }
        }
    >
        {userAuthenticated ?
            <>
                <Button
                    className="flex-grow-1 flex-lg-grow-0"
                    variant="primary"
                    style={
                        {
                            display: `flex`,
                            alignItems: `center`,
                            overflow: `hidden`,
                            justifyContent: `center`,
                            ...(!breakpoints.md ? {
                                height: '32px'
                            } : {})
                        }
                    }

                    onClick={
                        () => {
                            setLogout(true);
                        }
                    }
                    key={createUUID()}
                >
                    <span
                        className="flex-shrink-0"
                    >
                        {t(`AuthActions.log-out`)}
                    </span>
                </Button>
            </> : null
        }
    </ButtonToolbar >
}

export default AuthActions;
